// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fs","advertDetailService__price":"c-o_ft"};